import { render, staticRenderFns } from "./editPlate.vue?vue&type=template&id=9856a006&scoped=true&"
import script from "./editPlate.vue?vue&type=script&lang=js&"
export * from "./editPlate.vue?vue&type=script&lang=js&"
import style0 from "./editPlate.vue?vue&type=style&index=0&id=9856a006&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9856a006",
  null
  
)

export default component.exports